import React, { useEffect, useState } from "react";
import { Select, Button, Divider } from "antd";
// import { FormInstance } from "antd/es/form"; // Import FormInstance type

const { Option } = Select;

interface MutlSelectAntdComponentIF {
  options: any;
  placeholder: string;
  disabled?: boolean;
  onChangeHandler?: (selectedValues: string[]) => void;
  name?: string;
  form?: any;
  defaultValues?: any;
}
const filterOption = (input: string, option: any) => {
  return (option?.children.toString() ?? "")
    .toLowerCase()
    .includes(input.toLowerCase());
};
const MutlSelectAntdComponent: React.FC<MutlSelectAntdComponentIF> = ({
  options,
  placeholder,
  disabled,
  onChangeHandler,
  form,
  name,
  defaultValues,
}: MutlSelectAntdComponentIF) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  useEffect(() => {
    if (name && form) {
      const formValues = form.getFieldsValue();
      setSelectedItems(formValues[name] || []);
    }
  }, [form, name]);
  useEffect(() => {
    if (form) {
      if (form.getFieldValue([name]) && !form.getFieldValue([name]).length) {
        setSelectedItems([]);
      }
    }
  }, [form, name, form.getFieldValue([name])]);
  useEffect(() => {
    if (defaultValues) {
      setSelectedItems(defaultValues);
    }
  }, [defaultValues]);
  const handleChange = (selectedValues: string[]) => {
    setSelectedItems(selectedValues);
    if (onChangeHandler) onChangeHandler(selectedValues);
    if (form && name) {
      form.setFieldsValue({ [name]: selectedValues });
      form.validateFields([name]);
    }
  };

  const handleSelectAll = () => {
    const allValues = options.map((option: any) => option.value);
    setSelectedItems(allValues);
    if (onChangeHandler) onChangeHandler(allValues);
    if (form && name) {
      form.setFieldsValue({ [name]: allValues });
      form.validateFields([name]);
    }
  };

  const handleDeselectAll = () => {
    setSelectedItems([]);
    if (onChangeHandler) onChangeHandler([]);
    if (form && name) {
      form.setFieldsValue({ [name]: [] });
      form.validateFields([name]);
    }
  };

  const dropdownRender = (menu: React.ReactElement) => (
    <div>
      <div
        style={{ display: "flex", justifyContent: "space-between", padding: 0 }}
      >
        <Button type="link" onClick={handleSelectAll}>
          Select All
        </Button>
        <Button type="link" onClick={handleDeselectAll}>
          Deselect All
        </Button>
      </div>
      <Divider style={{ margin: 0 }} />
      {menu}
    </div>
  );

  return (
    <div>
      <Select
        mode="multiple"
        placeholder={placeholder}
        value={selectedItems}
        disabled={disabled}
        onChange={handleChange}
        style={{ width: "100%" }}
        dropdownRender={dropdownRender}
        maxTagCount={1}
        maxTagPlaceholder={(omittedValues) => (
          <span>+{omittedValues.length}...</span>
        )}
        filterOption={filterOption}
      >
        {options &&
          options.length &&
          options.map((option: any) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default MutlSelectAntdComponent;
